export default __webpack_public_path__ + "static/persona_cta-709ec1b517a630968c4354040c7e3936.png";